import moment from 'moment/moment';

function getRelativeDateOffsetsInSeconds(startDate, endDate, relativeTo = moment.utc()) {
  const fromOffset = moment.utc(startDate).diff(relativeTo, 'seconds');
  const toOffset = moment.utc(endDate).diff(relativeTo, 'seconds');

  return {
    fromOffset,
    toOffset,
  };
}

export function getRelativeDates(dateStartUTC, dateEndUTC, updatedAtUTC) {
  const {fromOffset, toOffset} = getRelativeDateOffsetsInSeconds(dateStartUTC, dateEndUTC, updatedAtUTC);
  const relativeStartDate = moment().add(fromOffset, 'seconds').toISOString();
  const relativeEndDate = moment().add(toOffset, 'seconds').toISOString();

  // these are returned in UTC
  return {
    relativeStartDate,
    relativeEndDate,
  };
}
